var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"gmp-page gmp-page--no-newsletter"},[_c('PICK_subpagehero'),_c('PICK_two_column_text'),_c('PICK_two_column_fullbleed')],1)}
var staticRenderFns = []

export { render, staticRenderFns }